import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  progressList: []
};

export default function visaProgress(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取签证办理进度
    case ACTION_TYPES.GET_VISA_PROGRESS_INFO:
      result.progressList = payload;
      break;
    default:
      result = state;
  }
  return result;
}
